import { useTranslation } from "react-i18next";
import { setLanguageToLS } from "../../utils/localStorage";

const Languages = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const nextLang = i18n.language === "vi" ? "en" : "vi";
    i18n.changeLanguage(nextLang);
    setLanguageToLS(nextLang);
  };

  const currentLang = i18n.language === "vi" ? "VI" : "EN";

  return (
    <span
      className="font-bold select-none cursor-pointer hover:text-primary transition-colors text-sm"
      onClick={toggleLanguage}
      title={currentLang === "VI" ? "Switch to English" : "Chuyển sang Tiếng Việt"}
    >
      {currentLang}
    </span>
  );
};

export default Languages;
